import { render } from "./_packageId.vue?vue&type=template&id=4b85864c&scoped=true&bindings={\"onlyPackage\":\"options\",\"packagesNumber\":\"options\",\"colsNumber\":\"options\",\"services\":\"options\",\"tablePackages\":\"options\",\"rendimentoAnnuoSmart\":\"options\",\"rendimentoAnnuo\":\"options\",\"firstPackageHasTrasholds\":\"options\"}"
import script from "./_packageId.vue?vue&type=script&lang=js"
export * from "./_packageId.vue?vue&type=script&lang=js"

import "./_packageId.vue?vue&type=style&index=0&id=4b85864c&lang=postcss&scoped=true&vars=%7B%20packagesNumber%20%7D"
script.render = render
script.__scopeId = "data-v-4b85864c"

export default script